<template>
  <div class="p-0 md:p-2 flex flex-col items-center justify-center">
    <div class="container max-w-screen-lg mx-auto">
      <div>
        <div id="form-fields" class="md:p-8 mb-6">
          <div
            class="bg-white rounded shadow-lg p-4 px-4 md:-mt-6 grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3"
          >
            <div class="text-left block">
              <p class="mb-2 font-medium text-lg text-gray-800">
                {{ descriptionTitle }}
              </p>
            </div>

            <div class="lg:col-span-2">
              <div
                class="p-6 space-y-4 max-w-4xl mx-auto bg-white rounded shadow"
              >
                <!-- CARROSSEL -->
                <!-- <section>
                  <h2 class="text-xl font-semibold border-b pb-2 mb-4 text-start">
                    🎞️ Carrossel de Destaque
                  </h2>
                  <div
                    v-for="(slide, index) in store.state.data.carousel"
                    :key="index"
                    class="flex flex-col md:flex-row md:items-center gap-4 mb-4 w-full"
                  >
                    <input
                      type="file"
                      @change="updateImage($event, index)"
                      class="block w-full md:w-auto"
                    />
                    <button
                      @click="removeSlide(index)"
                      class="text-red-600 hover:underline"
                    >
                      Remover
                    </button>
                  </div>
                  <button
                    @click="addSlide"
                    class="text-blue-600 hover:underline"
                  >
                    + Adicionar Slide
                  </button>
                </section> -->

                <!-- DESCRIÇÃO INICIAL -->
                <!-- <div class="md:col-span-5">
                  <h2 class="text-xl font-semibold text-start">
                    Descrição inicial <a class="text-red-600 ml-1">*</a>
                  </h2>
                  <div
                    class="mx-1 my-2"
                  >
                    <textarea
                      name="desc"
                      v-model="store.state.data.mainDesc"
                      class="input-field"
                    >
                    </textarea>
                  </div>

                  <span
                    name="highlights.first.desc"
                    class="text-red-600 text-sm"
                  />
                </div> -->

                <!-- CARD PRINCIPAL -->
                <div class="md:col-span-2">
                  <h2 class="text-xl font-semibold text-start">
                    Treinamento em destaque
                  </h2>
                  <div
                    class="h-10 flex rounded items-center mt-1.5 w-full"
                  >
                  <SimpleSelect
                    class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                    :data="events"
                    :initial-value="dataStock.state.data.mainEvent"
                    @selected-data="(val) => (dataStock.state.data.mainEvent = val)"
                  />
                  </div>
                </div>

                <!-- LOGIN -->
                <div class="md:col-span-5">
                  <h2 class="text-xl font-semibold text-start">
                    Imagem do login
                  </h2>

                  <div class="md:col-span-5 mt-2 flex h-10">
                    <label
                      class="cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all min-w-[8rem] h-10 rounded-l-md rounded-r-none"
                    >
                      <div class="flex mt-auto mb-auto h-full">
                        <div class="w-full mt-auto mb-auto flex justify-center">
                          <component
                            :is="PhFileImage"
                            class="w-5 h-5 mr-1 text-green-500"
                          />

                          Banner
                        </div>
                      </div>
                      <input
                        type="file"
                        class="hidden"
                        @change="(e) => handleFileChange(e, 'login')"
                      />
                    </label>
                    <input
                      type="text"
                      style="padding-left: 10px !important"
                      class="border rounded w-full h-10 rounded-r-md rounded-l-none"
                      :value="store.state.data.loginImage"
                    />
                  </div>
                </div>

                <!-- SALVAR -->
                <div class="text-right flex justify-center md:justify-end">
                  <slot />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

import { dataStock } from '../store'
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import { PhCaretUp, PhFileImage } from '@phosphor-icons/vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import CleanInputButton from '../components/CleanInputButton.vue'
import stockService from '../services/stock.service'
import { showToast as toast } from '@/helpers/UseToasts'

defineProps({
  descriptionTitle: {
    required: true,
    String
  }
})

const firstHighlight = ref(false)
const secondHighlight = ref(false)
const thirdHighlight = ref(false)

const events = computed(() => dataStock.getters.getEventsCollect)
const store = dataStock

function toggleTab (val) {
  switch (val) {
    case 'first':
      firstHighlight.value = !firstHighlight.value
      secondHighlight.value = false
      thirdHighlight.value = false
      break

    case 'second':
      secondHighlight.value = !secondHighlight.value
      firstHighlight.value = false
      thirdHighlight.value = false
      break

    case 'third':
      thirdHighlight.value = !thirdHighlight.value
      secondHighlight.value = false
      firstHighlight.value = false
      break
  }
}

async function handleFileChange (event, state) {
  const file = event.target.files[0]
  if (file) {
    const allowedExtensions = ['webp', 'png', 'gif', 'jpeg', 'jpg']
    const fileExtension = file.name.split('.').pop().toLowerCase()
    if (allowedExtensions.includes(fileExtension)) {
      dataStock.dispatch('setUploadFile', true)
      if (state == 'first') {
        store.state.data.highlights.first.selectedFileName = file.name

        try {
          const res = await stockService.saveImage(file)

          store.state.data.highlights.first.image = res.data
          dataStock.dispatch('setUploadFile', false)
        } catch (err) {
          dataStock.dispatch('setUploadFile', false)
          toast('Erro', 'Upload do destaque 1 falhou', 'error')
        }
      }
      if (state == 'second') {
        store.state.data.highlights.second.selectedFileName = file.name

        try {
          const res = await stockService.saveImage(file)

          store.state.data.highlights.second.image = res.data
          dataStock.dispatch('setUploadFile', false)
        } catch (err) {
          dataStock.dispatch('setUploadFile', false)
          toast('Erro', 'Upload do destaque 2 falhou', 'error')
        }
      }
      if (state == 'third') {
        store.state.data.highlights.third.selectedFileName = file.name

        try {
          const res = await stockService.saveImage(file)

          store.state.data.highlights.third.image = res.data
          dataStock.dispatch('setUploadFile', false)
        } catch (err) {
          dataStock.dispatch('setUploadFile', false)
          toast('Erro', 'Upload do destaque 3 falhou', 'error')
        }
      }
      if (state == 'login') {
        store.state.data.loginImage = file.name

        try {
          const res = await stockService.saveImage(file)

          store.state.data.loginImage = res.data
          dataStock.dispatch('setUploadFile', false)
        } catch (err) {
          dataStock.dispatch('setUploadFile', false)
          toast('Erro', 'Upload da iamgem do login falhou', 'error')
        }
      }
    } else {
      dataStock.dispatch('setUploadFile', false)
      return this.toast(
        'Atenção',
        'Apenas imagens do tipo: webp, png, gif, jpeg e jpg são aceitas',
        'info'
      )
    }
  }
}

// fluxo do carrossel
const updateImage = async (e, index) => {
  dataStock.dispatch('setUploadFile', true)
  const file = e.target.files[0]
  if (!file) return

  const allowedExtensions = ['webp', 'png', 'gif', 'jpeg', 'jpg']
  const fileExtension = file.name.split('.').pop().toLowerCase()

  if (!allowedExtensions.includes(fileExtension)) {
    toast('Atenção', 'Apenas imagens do tipo: webp, png, gif, jpeg e jpg são aceitas', 'info')
    return
  }

  try {
    const res = await stockService.saveImage(file)

    store.state.data.carousel[index] = res.data
    dataStock.dispatch('setUploadFile', false)
  } catch (err) {
    dataStock.dispatch('setUploadFile', false)
    toast('Erro', 'Upload de imagem falhou', 'error')
  }
}
const addSlide = async () => {
  store.state.data.carousel.push(null)
}
const removeSlide = (index) => {
  store.state.data.carousel.splice(index, 1)
}

</script>

<style lang="scss" scoped>
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}

.input-field {
  display: block;
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border-radius: 10px;
  border: 2px solid #ccc;
  outline: none;
  background-color: transparent;
  transition: border-color 0.3s ease-in-out;
}
</style>
